export default {"src":"/_next/static/media/logo-white.cbeb05c4.svg","height":96,"width":551,"blurWidth":0,"blurHeight":0};